import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import {
  campaignsService,
  CampaignValueCards,
  UpdateCampaignValueCardsRequest,
} from '@aslanpay/portal-common-lib';

export interface UpdateCampaignValueCardsMutation {
  campaignId: string;
  request: UpdateCampaignValueCardsRequest;
}

const useUpdateCampaignValueCards = (
  options: UseMutationOptions<CampaignValueCards, Error, UpdateCampaignValueCardsMutation>
) => {
  return useMutation<CampaignValueCards, Error, UpdateCampaignValueCardsMutation>(
    ({ campaignId, request }) => campaignsService.updateCampaignValueCards(campaignId, request),
    options
  );
};

export default useUpdateCampaignValueCards;
